import { gql } from "@apollo/client";
import { AIMessageFragments } from "./GPTPlaygroundFragments";

export const deleteMemoriesMutation = gql`
  mutation deleteMemories($input: DeleteAiMemoriesInput!) {
    ai {
      deleteAiMemories(input: $input) {
        isSuccess
      }
    }
  }
`;

export const createAIMessageMutation = gql`
  mutation createAiMessage($input: CreateAiMessageInput!) {
    ai {
      createAiMessage(input: $input) {
        isSuccess
        response {
          ...aiMessageItem
        }
      }
    }
  }
  ${AIMessageFragments.AIMessage}
`;

export const updateAIMessageMutation = gql`
  mutation updateAiMessage($input: UpdateAiMessageInput!) {
    ai {
      updateAiMessage(input: $input) {
        isSuccess
        response {
          ...aiMessageItem
        }
      }
    }
  }
  ${AIMessageFragments.AIMessage}
`;

export const deleteAIMessageMutation = gql`
  mutation deleteAiMessage($input: DeleteAiMessageInput!) {
    ai {
      deleteAiMessage(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;
